import { useBulkImportInvestmentAreasMutation } from 'generated/graphql';



export function useUploadInvestmentAreasModal() {
  const [bulkImportInvestmentAreas, tuple] = __useBulkImportInvestmentAreasMutation();



  return {
    ...tuple,
    mutations: { bulkImportInvestmentAreas }
  };
}



function __useBulkImportInvestmentAreasMutation() {
  const [fnMutate, tuple] = useBulkImportInvestmentAreasMutation();

  async function fnWrappedMutate(displayNames: string[]) {
    await fnMutate({
      variables: {
        input: { displayNames }
      }
    });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
